<base-support-modal [title]="title" [btnOkClass]="'btn-warning'" [btnOkLabel]="'Установить'" (onOk)="ok()">
	<div class="form-group" [formGroup]="form">
		<label>Divly partner Id</label>
		<input class="form-control" type="text" formControlName="divlyId" [(ngModel)]="divlyId">		
	</div>
</base-support-modal>
